<button mat-button class="doc-btn-success" (click)="openUploader()">
  Upload
  <mat-icon class="attachmentIcon">
    <i class="fi-rr-clip"></i>
  </mat-icon>
</button>
